// LIBRARIES
import { createAsyncThunk } from "@reduxjs/toolkit";

// MISC
import { REST } from "config/axiosConfig";
import { ICreatePromoCode, IEditPromoCode, IUsersApiParams } from "models/interfaces";

export const getPromoCodes = createAsyncThunk(
  "promo-codes/getPromoCodes",
  async (data: any) => {
    try {
      const response = await REST.get(
        `/promo-codes/get-promo-codes?page=${data.page}&size=12`,
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const getPromoCodeUsers = createAsyncThunk(
  "promo-codes/getPromoCodeUsers",
  async (id: number) => {
    try {
      const response = await REST.get(
        `/promo-codes/get-promo-code-users?promoCodeId=${id}`,
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const createPromoCode = createAsyncThunk(
  "promo-codes/getPromoCodes",
  async (payload: ICreatePromoCode) => {
    try {
      const response = await REST.post(
        `/promo-codes/create-promo-code`, payload
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const editPromoCode = createAsyncThunk(
  "promo-codes/editPromoCode",
  async (payload: IEditPromoCode) => {
    try {
      const response = await REST.put(
        `/promo-codes/edit-promo-code?isValid=${payload.isValid}&promoCodeId=${payload.promoCodeId}`,
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);


